<!--首页-->
<template>
  <div class="index">


    <!--      <el-image aria-hidden="true" class="bgs" src="/static/image/load_results/BG1.png"></el-image>-->

    <div class="bg">
      <div class="progres">
        <el-progress color="#FFBD39" class="progress" :text-inside="true" :stroke-width="24" :percentage="percentage"
                     status="success"></el-progress>
        <p tabindex="1" id="title-p">
          <el-image role="text" aria-label="正在为你找朋友！" class="tips"
                    src="/static/image/load_results/文字.png"></el-image>
        </p>
      </div>
    </div>

  </div>


</template>


<script>


import $ from "jquery";

export default {
  name: 'index',
  data() {
    return {
      percentage: 0,
    }
  },
  created() {


  },
  mounted() {
    this.$nextTick(function () {
      // 获取元素距离顶部的距离跟可视区域的高度
      const h = screen.height
      const w = screen.width
      this.start()
      document.getElementById('title-p').focus()
      if (w <= 500) {
        if (h <= 700) {
          $(".progres").css({"padding-top": "7rem"})
          // $(".title").css({"margin-top": ((h / 100) * 1.5) + 100 + "px"})
        }
      } else {
        if (h >= 900) {
          $(".progres").css({"padding-top": "6rem"})
          $(".tips").css({"margin-top": "0.3rem"})
        }
      }
    })
  },
  computed: {},
  methods: {


    start: function () {
      var s = window.setInterval(() => {
        setTimeout((() => {
          if (this.percentage >= 100) {
            window.clearInterval(s);
            setTimeout((() => {
              this.$router.replace('/match_result')
            }), 700);
          } else {
            this.percentage += 1
          }

        }), 0)
      }, 10)
    }

  }

}
</script>


<style scoped>

.index {
  height: 100vh;
  background-image: url("/static/image/load_results/资源 68.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
}

/*.text{*/

/*text-align: center;*/
/*font-size: 0.3rem;*/
/*}*/

.progres {
  /*background: #3a8ee6;*/
  width: 60%;
  margin-left: 20%;
  padding-top: 9rem;

}

/*去掉获得焦点的边框*/
p {
  outline: none;
}

.tips {
  width: 60%;
  margin-top: 0.6rem;
  margin-left: 20%;
}

</style>



// WEBPACK FOOTER //
// src/components/home/load_results.vue